var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{staticClass:"alert-modal"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('AeButtonGroup',[(_vm.confirm)?_c('AeButton',{attrs:{"fill":"secondary"},on:{"click":_vm.cancelHandler}},[_vm._v(" "+_vm._s(_vm.$t('cancel'))+" ")]):_vm._e(),_c('AeButton',{on:{"click":_vm.resolve}},[_vm._v(" "+_vm._s(_vm.primaryButtonText)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }